<main class="container-fluid p-0 h-100">
  <div class="row justify-content-center d-flex align-items-center h-100">
    <div id="success" class="col-7 col-md-7 col-lg-5 col-xl-4 login-container">
      <div class="row logo login--heading login--heading__register">
        <section class="col-12">
          <h1 aria-level="1" class="float-left">Verification Complete!</h1>
          <img src="assets/images/logo.svg#logo" alt="Learningmate - Frost align" class="float-right" />
        </section>

        <div class="col-12 mt-5">
          <p>You have successfully verified your email address!</p>
          <p>To begin using Frost align you can click on the button below.</p>
          <div class="col-12 p-0">
            <button class="btn btn-primary btn__login" [disabled]="enableProceed" (click)="goToLogin()">Login</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
